import {
  BatchExportDocumentReference,
  BatchJobExecutionDetails,
  ColumnSpecification,
} from '@rygen/rygen-ui/model';

import { ShipmentSearchCriteria, ShipmentSearchExportCriteria } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment/search/export';

export class ShipmentSearchExportController extends BaseHttpController {
  constructor() {
    super(endpoint, { useSelectedDomainContext: true });
  }

  async export(
    query: ShipmentSearchCriteria,
    columns: ColumnSpecification[],
  ): Promise<BatchJobExecutionDetails> {
    const searchExportCriteria = new ShipmentSearchExportCriteria({
      query: query,
      visibleColumns: columns.map((col) => col.field),
    });

    const response = await this.http.post<BatchJobExecutionDetails>(
      '',
      searchExportCriteria,
    );
    return new BatchJobExecutionDetails(response.data);
  }

  async getJobStatus(jobId: number): Promise<BatchJobExecutionDetails> {
    const response = await this.http.get<BatchJobExecutionDetails>(
      `job/${jobId}`,
    );
    return new BatchJobExecutionDetails(response.data);
  }

  async getDocument(jobId: number): Promise<BatchExportDocumentReference> {
    const response = await this.http.get<BatchExportDocumentReference>(
      `job/${jobId}/document`,
    );
    return new BatchExportDocumentReference(response.data);
  }
}
